import { IconAnimals } from '../../../common/icons';
import SummaryCard from '../../../common/components/summary-card';
import { fmtMoney, fmtPct } from '../../../core/utils/format';
import { useClientDonors } from '../contexts/donors';

// TSS vite/03 — resumen de cowhousing (donadoras co-poseídas) para el home.
// Reusa useClientDonors con un limit chico: total + preview de las primeras
// donadoras con su participación y valor de participación, con CTA a la vista
// completa. Contract: GET public/donors?view=summary (public-client-channel.md).
//
// El hook devuelve el SOBRE público completo (0052): items/pagination viven en
// envelope.data. El backend es dueño de los números (stake_value ya derivado);
// acá solo se formatea con fmtMoney/fmtPct.

const PREVIEW = 3;

export default function CowhousingSummary() {
    const { data: envelope, isLoading, isError, error } =
        useClientDonors({ view: 'summary', limit: PREVIEW });

    const items = envelope?.data?.items ?? [];
    const total = envelope?.data?.pagination?.total ?? items.length;

    const count = isLoading || isError
        ? null
        : `${total} donadora${total === 1 ? '' : 's'}`;

    return (
        <SummaryCard
            icon={<IconAnimals />}
            title="Mis vacas"
            count={count}
            to="/mis-vacas"
            ctaLabel="Ver todas mis vacas →"
        >
            {isLoading ? (
                <p className="summary-card__state">Cargando donadoras…</p>
            ) : isError ? (
                <p className="summary-card__state summary-card__state--error">
                    {error?.message || 'No se pudieron cargar tus donadoras'}
                </p>
            ) : !items.length ? (
                <p className="summary-card__state">Aún no tienes donadoras en cowhousing.</p>
            ) : (
                <ul className="summary-card__list">
                    {items.map((donor) => (
                        <li key={donor.id} className="summary-card__row">
                            <span className="summary-card__row-main">
                                <span className="summary-card__row-name">
                                    {donor.name || `Donadora #${donor.id}`}
                                </span>
                                <span className="summary-card__row-sub">
                                    Nº {donor.number} · Participación {fmtPct(donor.percent)}
                                </span>
                            </span>
                            <span className="summary-card__amount">
                                {fmtMoney(donor.stake_value)}
                            </span>
                        </li>
                    ))}
                </ul>
            )}
        </SummaryCard>
    );
}
